document.addEventListener("DOMContentLoaded", function () {
  function CountdownTimer(element) {
    this.element = element;
    this.wrapper = element.closest(".countdown-wrapper");
    this.timeFrom = element.getAttribute("time-from");
    this.timeTill = element.getAttribute("time-till");
    this.dateTimeTill = element.getAttribute("datetime-till");
    this.saturdayCheck = element.getAttribute("data-saturday-check") === "true";
    this.sundayCheck = element.getAttribute("data-sunday-check") === "true";
    this.interval = null;
    this.showDays = element.getAttribute("data-days") === "true";
    this.init();
  }

  CountdownTimer.prototype.init = function () {
    if ((!this.timeFrom || !this.timeTill) && !this.dateTimeTill) {
      console.error("time-from en time-till attributen zijn vereist, of een datetime-till attribuut.");
      return;
    }

    if (this.dateTimeTill) {
      this.initDateTime();
      return;
    }

    if (this.dateTimeTill) {
      this.initDateTime();
      return;
    }

    let now = new Date();
    let currentDay = now.getDay(); // 0 = zondag, 6 = zaterdag

    if (
      (this.saturdayCheck && currentDay === 6) ||
      (this.sundayCheck && currentDay === 0)
    ) {
      this.timerEnded(); // Verberg de timer als het zaterdag of zondag is en de check is true
      return;
    }

    let fromTime = this.getTime(this.timeFrom);
    let tillTime = this.getTime(this.timeTill);

    if (now >= fromTime && now <= tillTime) {
      this.startCountdown(tillTime);
    } else {
      this.timerEnded();
    }
  };

  CountdownTimer.prototype.initDateTime = function () {
    let now = new Date();
    let targetTime = new Date(this.dateTimeTill);
    console.log('targetTime', targetTime);
    
    if (now <= targetTime) {
      this.startCountdown(targetTime);
    } else {
      this.timerEnded();
    }
  }

  CountdownTimer.prototype.getTime = function (timeStr) {
    let timeParts = timeStr.split(":");
    let now = new Date();
    now.setHours(parseInt(timeParts[0]));
    now.setMinutes(parseInt(timeParts[1]));
    now.setSeconds(0);
    return now;
  };

  CountdownTimer.prototype.startCountdown = function (targetTime) {
    let self = this;

    const showLabels = this.element.getAttribute('data-show-labels') === 'true';
    const daysLabel = this.element.getAttribute('data-name-days') || 'Days';
    const hoursLabel = this.element.getAttribute('data-name-hours') || 'Hours';
    const minutesLabel = this.element.getAttribute('data-name-minutes') || 'Minutes';
    const secondsLabel = this.element.getAttribute('data-name-seconds') || 'Seconds';
    const groupStyle = this.element.getAttribute('data-group-style') || 'unit';

    this.interval = setInterval(function () {
      let now = new Date();
      let remainingTime = targetTime - now;

      if (remainingTime <= 0) {
        clearInterval(self.interval);
        self.timerEnded();
        return;
      }

      let days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));

      let hours = Math.floor(
        (remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      let minutes = Math.floor(
        (remainingTime % (1000 * 60 * 60)) / (1000 * 60)
      );
      let seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

      let countdownHTML = '';
      if (self.showDays) {
        let digit = `<span class="digit">${self.formatTime(days).toString()}</span>`;

        if (groupStyle === 'individual') {
          digit = `<span class="digit">${self.formatTime(days).toString().slice(0, 1)}</span>
            <span class="digit">${self.formatTime(days).toString().slice(1)}</span>`;
        }

        countdownHTML = `<span class="days">
          <div class="digit-wrapper">
            ${digit}
          </div>
          ${showLabels ? `<span class="label">${daysLabel}</span>` : ''}
        </span>:`
      }

      let hoursDigit = `<span class="digit">${self.formatTime(hours).toString()}</span>`;
      let minutesDigit = `<span class="digit">${self.formatTime(minutes).toString()}</span>`;
      let secondsDigit = `<span class="digit">${self.formatTime(seconds).toString()}</span>`;
      if (groupStyle === 'individual') {
        hoursDigit = `<span class="digit">${self.formatTime(hours).toString().slice(0, 1)}</span>
          <span class="digit">${self.formatTime(hours).toString().slice(1)}</span>`;

        minutesDigit = `<span class="digit">${self.formatTime(minutes).toString().slice(0, 1)}</span>
          <span class="digit">${self.formatTime(minutes).toString().slice(1)}</span>`;

        secondsDigit = `<span class="digit">${self.formatTime(seconds).toString().slice(0, 1)}</span>
          <span class="digit">${self.formatTime(seconds).toString().slice(1)}</span>`;
      }

      countdownHTML += `
      <span class="hours">
        <div class="digit-wrapper">
          ${hoursDigit}
        </div>
        ${showLabels ? `<span class="label">${hoursLabel}</span>` : ''}
      </span>:<span class="minutes">
        <div class="digit-wrapper">
          ${minutesDigit}
        </div>
        ${showLabels ? `<span class="label">${minutesLabel}</span>` : ''}
      </span>:<span class="seconds">
        <div class="digit-wrapper">
          ${secondsDigit}
        </div>
        ${showLabels ? `<span class="label">${secondsLabel}</span>` : ''} 
      </span>`;

      self.element.innerHTML = countdownHTML;
    }, 1000);
  };

  CountdownTimer.prototype.formatTime = function (unit) {
    return unit < 10 ? "0" + unit : unit;
  };

  // CountdownTimer.prototype.timerEnded = function () {
  //   if (this.wrapper) {
  //     this.wrapper.style.display = "none";
  //     document.querySelector('.promo-countdown__container').style.display = 'none';
  //   }
  // };

  CountdownTimer.prototype.timerEnded = function () {
    if (this.wrapper) {
        this.wrapper.style.display = "none";
        // Alleen verbergen als de container binnen de wrapper zit
        // const promoContainer = this.wrapper.querySelector('.promo-countdown__container');
        const promoContainer = document.querySelector('.promo-countdown__container');
        if (promoContainer) {
            promoContainer.style.display = 'none';
        }
    }
};

  document.querySelectorAll(".timer").forEach(function (timerElement) {
    new CountdownTimer(timerElement);
  });
});
